<script lang="ts">
  import Input from './base/Input.svelte'

  export let label: string | undefined = undefined
  export let name: string | undefined = undefined
  export let id: string | undefined = undefined
  export let length = 6
  let min = Math.pow(10, length - 1)
  let max = Math.pow(10, length) - 1
  let hiddenInputValue: string

  function focusPrevious(input: HTMLInputElement | null) {
    const previousInput =
      input?.previousElementSibling as HTMLInputElement | null

    if (previousInput) {
      previousInput.focus()
    }
  }

  function focusNext(input: HTMLInputElement | null) {
    const nextInput = input?.nextElementSibling as HTMLInputElement | null

    if (nextInput) {
      nextInput.focus()
    }
  }

  function handleInput(event: Event) {
    const input = event.target as HTMLInputElement | null
    const inputEvent = event as InputEvent // on:input is typed as Event

    if (
      inputEvent.inputType !== 'deleteContentBackward' &&
      input?.nextElementSibling
    ) {
      input.blur()
    }
  }

  function handleChange(event: Event) {
    const input = event.target as HTMLInputElement | null

    if (input?.value) {
      hiddenInputValue = `${hiddenInputValue}${input.value}`
      focusNext(input)
    } else {
      hiddenInputValue = hiddenInputValue.slice(0, -1)
      focusPrevious(input)
    }
  }

  function handleKeydown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement | null

    if (
      event.key === 'ArrowLeft' ||
      (event.key === 'Backspace' && input?.value === '')
    ) {
      focusPrevious(input)
    } else if (event.key === 'ArrowRight') {
      focusNext(input)
    }
  }

  function handlePaste(event: ClipboardEvent) {
    let currentInput = event.target as HTMLInputElement | null
    const data = event.clipboardData?.getData('text/plain')

    if (data) {
      hiddenInputValue = data

      for (let c of data) {
        const nextInput =
          currentInput?.nextElementSibling as HTMLInputElement | null

        if (currentInput) {
          currentInput.value = c
          focusNext(currentInput)
          currentInput = nextInput
        }
      }
    }
  }
</script>

<label for={name}>{label}</label>
<div class="verification-container">
  {#each Array(length) as _, i (i)}
    <!-- svelte-ignore a11y-autofocus -->
    <input
      type="text"
      autocomplete="one-time-code"
      id={`${id}-${i}`}
      maxlength={1}
      autofocus={i === 0}
      on:input={handleInput}
      on:keydown={handleKeydown}
      on:paste={handlePaste}
      on:change={handleChange}
    />
  {/each}
</div>
<Input
  type="text"
  hidden
  {name}
  {id}
  {min}
  {max}
  bind:value={hiddenInputValue}
/>

<style lang="scss">
  label {
    font-size: var(--label-font-size);
    color: var(--color-on-background);
  }

  .verification-container {
    display: flex;
    justify-content: center;
    gap: 1em;
    width: 100%;
    flex-wrap: wrap;

    input {
      box-sizing: border-box;
      font-family: 'Helvetica Neue';
      height: 64px;
      width: 64px;
      text-align: center;
      font-size: 36px;
      background: var(--input-background);
      border: var(--input-border);
      border-radius: var(--input-border-radius);
      box-shadow: var(--input-box-shadow);
      transition: background-color 0.125s;

      &:focus-within {
        outline-color: -webkit-focus-ring-color;
        outline-style: auto;
        outline-width: 1px;
        overflow: hidden;
      }

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }
</style>
